import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.9529 10.35C16.9529 10.2191 16.9016 10.0935 16.81 9.99999L13.95 7.17999C13.9035 7.13313 13.8482 7.09593 13.7873 7.07055C13.7264 7.04516 13.661 7.03209 13.595 7.03209C13.529 7.03209 13.4636 7.04516 13.4027 7.07055C13.3418 7.09593 13.2865 7.13313 13.24 7.17999L5.17 15.25C4.9749 15.4434 4.82172 15.6748 4.72 15.93L3 20.27C2.95283 20.3791 2.94605 20.5014 2.98087 20.615C3.01568 20.7286 3.08983 20.8261 3.19 20.89C3.25934 20.9592 3.34748 21.0065 3.44348 21.0261C3.53948 21.0457 3.63912 21.0366 3.73 21L8.07 19.24C8.32517 19.1383 8.55664 18.9851 8.75 18.79L16.81 10.7C16.9016 10.6065 16.9529 10.4809 16.9529 10.35ZM19.9 3.43999L20.56 4.09999C20.8414 4.38103 20.9997 4.7623 21 5.15999V5.91999C21.0025 6.12027 20.9648 6.31901 20.8893 6.5045C20.8137 6.68999 20.7017 6.85847 20.56 6.99999L18.71 8.81999C18.6635 8.86686 18.6082 8.90405 18.5473 8.92944C18.4864 8.95482 18.421 8.96789 18.355 8.96789C18.289 8.96789 18.2236 8.95482 18.1627 8.92944C18.1018 8.90405 18.0465 8.86686 18 8.81999L15.19 5.96999C15.0984 5.87653 15.0471 5.75087 15.0471 5.61999C15.0471 5.48912 15.0984 5.36346 15.19 5.26999L17 3.43999C17.1415 3.29826 17.31 3.18631 17.4955 3.11074C17.681 3.03517 17.8797 2.99751 18.08 2.99999H18.84C19.2377 3.00034 19.619 3.15861 19.9 3.43999Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgEdit = (props: IconProps) => <SVGUniqueID>{Icon(props)}</SVGUniqueID>;
export default SvgEdit;
